module.exports = __webpack_public_path__ + "static/media/Facebook.6acb3d23.svg";